import { Link } from "react-router-dom";

const columns = [
  {
    title: "Produit",
    links: [
      { label: "Fonctionnalités", to: "/features", testid: "footer-link-features" },
      { label: "Tarifs", to: "/pricing", testid: "footer-link-pricing" },
      { label: "Connexion", href: "https://app.actipilote.com/login", testid: "footer-link-login" },
    ],
  },
  {
    title: "ActiPilote",
    links: [
      { label: "Contact", to: "/contact", testid: "footer-link-contact" },
      { label: "FAQ", to: "/#faq", testid: "footer-link-faq" },
    ],
  },
  {
    title: "Légal",
    links: [
      { label: "Mentions légales", to: "/legal", testid: "footer-link-legal" },
      { label: "Politique de confidentialité", to: "/privacy", testid: "footer-link-privacy" },
      { label: "Conditions générales", to: "/terms", testid: "footer-link-terms" },
    ],
  },
];

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-slate-200/70 bg-white">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <img src="/actipilote-logo.png" alt="ActiPilote" className="h-8 w-auto" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-navy/60">
            Pilotez toute votre activité. La plateforme tout-en-un des professionnels des activités touristiques et de loisirs.
          </p>
          <a href="mailto:contact@actipilote.com" data-testid="footer-email" className="mt-4 inline-block text-sm font-semibold text-brand hover:underline">
            contact@actipilote.com
          </a>
        </div>
        {columns.map((col) => (
          <div key={col.title}>
            <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-navy/40">{col.title}</h3>
            <ul className="mt-4 space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  {l.href ? (
                    <a href={l.href} data-testid={l.testid} className="text-sm font-medium text-navy/70 transition-colors hover:text-brand">{l.label}</a>
                  ) : (
                    <Link to={l.to} data-testid={l.testid} className="text-sm font-medium text-navy/70 transition-colors hover:text-brand">{l.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-slate-200/70 pt-6 text-xs text-navy/45 sm:flex-row sm:items-center">
        <p>© {new Date().getFullYear()} ActiPilote. Tous droits réservés.</p>
        <p>Application : <a href="https://app.actipilote.com" className="font-semibold text-navy/60 hover:text-brand" data-testid="footer-app-link">app.actipilote.com</a></p>
      </div>
    </div>
  </footer>
);

export default Footer;
